import React from 'react'
import { ArticoliImmaginiCollezioniObject } from '@gql/graphql'
import useTrans from '@hooks/useTrans'
import { Button, WImage } from '@components/atoms'
import styles from './ProdottoDetailCard.module.sass'

interface Props {
  item?: ArticoliImmaginiCollezioniObject
  className?: string
}

const ProdottoDetailCard = (props: Props) => {
  const { item = undefined, className = '' } = props

  const t = useTrans()

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.imageBox}>
        <WImage
          className={styles.image}
          src={item.image}
          alt={item?.imageAlt}
          maxWidth={104}
          maxHeight={104}
          objectFit="cover"
        />
      </div>
      <div className={styles.main}>
        <div className={styles.content}>
          {!!item.tonalitaNome && <h3 className={styles.title}>{item.tonalitaNome}</h3>}
          {!!item.finituraNome && (
            <p className={styles.description}>
              {t('Finitura')}: {item.finituraNome}
            </p>
          )}
        </div>
        <Button href={item.tonalitaUrl} variant="ghost" label={t('Scopri di più')} />
      </div>
    </div>
  ) : (
    <></>
  )
}

export default ProdottoDetailCard
